export const FIRST_PAGE = 1
export const PAGE_RANGE = 10
// tslint:disable-next-line:no-magic-numbers
export const HALF_PAGE_RANGE = PAGE_RANGE / 2



// WEBPACK FOOTER //
// ./src/app/shared/pagination/constants.ts